export default {
  days: {
    mo: "Po",
    tu: "Út",
    we: "St",
    th: "Čt",
    fr: "Pá",
    sa: "So",
    su: "Ne",
    monday: "Pondělí"
  },
  opening_hours: "Ordinační doba",
  opening_hours_holidays: "Prázdninová ordinační doba",
}



// WEBPACK FOOTER //
// ./src/texts/czech/main.js